"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var view_config_models_1 = require("./../view-config-models");
var PostponedFlightsControlNames = (function () {
    function PostponedFlightsControlNames() {
    }
    return PostponedFlightsControlNames;
}());
PostponedFlightsControlNames.noFlights = 'noFlights';
PostponedFlightsControlNames.flightsLater = 'flightsLater';
exports.PostponedFlightsControlNames = PostponedFlightsControlNames;
var POSTPONED_FLIGHTS_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return PostponedFlightsComponent; }),
    multi: true
};
var PostponedFlightsComponent = (function () {
    function PostponedFlightsComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.propagateChange = function (_) { };
        this.onTouched = function () { };
        this.buildForm();
    }
    PostponedFlightsComponent.prototype.buildForm = function () {
        var _this = this;
        this.form = this.formBuilder.group({});
        this.noFlightsControl = this.formBuilder.control(false, []);
        this.flightsLaterControl = this.formBuilder.control(undefined, []);
        this.form.addControl(PostponedFlightsControlNames.noFlights, this.noFlightsControl);
        this.form.addControl(PostponedFlightsControlNames.flightsLater, this.flightsLaterControl);
        this.form.valueChanges.subscribe(function (value) {
            _this.propagateChange(value);
            _this.onTouched();
        });
    };
    PostponedFlightsComponent.prototype.writeValue = function (obj) {
        var value = obj;
        updateControlWithValue(this.noFlightsControl, value.noFlights);
        updateControlWithValue(this.flightsLaterControl, value.flightsLater);
        function updateControlWithValue(control, value) {
            control.setValue(value);
            control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        }
    };
    PostponedFlightsComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    PostponedFlightsComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    PostponedFlightsComponent.prototype.setDisabledState = function (isDisabled) {
        if (isDisabled) {
            this.noFlightsControl.disable();
            this.flightsLaterControl.disable();
        }
        else {
            this.noFlightsControl.enable();
            this.flightsLaterControl.enable();
        }
    };
    return PostponedFlightsComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", view_config_models_1.PostponedFlightsConfig)
], PostponedFlightsComponent.prototype, "config", void 0);
PostponedFlightsComponent = __decorate([
    core_1.Component({
        selector: 'postponed-flights',
        template: "<div *ngIf=\"form?.controls\" [formGroup]=\"form\">     <div class=\"row\">         <div class=\"col-xs-12\">             <label>                 <bhtp-check-box formControlName=\"noFlights\"></bhtp-check-box>                 <span class=\"flights-now-prompt\" *ngIf=\"config?.flightsNowPrompt\">{{config.flightsNowPrompt}}</span>                 <ng-content select=\"[text-config=flights-now-prompt]\"></ng-content>             </label>         </div>     </div>     <ng-container *ngIf=\"noFlightsControl?.value\">         <div class=\"row\">             <div class=\"col-xs-12\">                 <h3 class=\"flights-later-prompt\" *ngIf=\"config?.flightsLaterPrompt\">{{config.flightsLaterPrompt}}</h3>                 <ng-content select=\"[text-config=flights-later-prompt]\"></ng-content>             </div>         </div>         <div class=\"row\">             <div class=\"col-xs-12\">                 <label>                     <bhtp-radio-button [formControl]=\"flightsLaterControl\" [value]=\"true\"></bhtp-radio-button>                     <span class=\"flights-later-positive\" *ngIf=\"config?.flightsLaterPositive\">{{config.flightsLaterPositive}}</span>                     <ng-content select=\"[text-config=flights-later-positive]\"></ng-content>                 </label>             </div>         </div>         <div class=\"row\">             <div class=\"col-xs-12\">                 <label>                     <bhtp-radio-button [formControl]=\"flightsLaterControl\" [value]=\"false\"></bhtp-radio-button>                     <span class=\"flights-later-negative\" *ngIf=\"config?.flightsLaterNegative\">{{config.flightsLaterNegative}}</span>                     <ng-content select=\"[text-config=flights-later-negative]\"></ng-content>                 </label>             </div>         </div>     </ng-container> </div>",
        providers: [POSTPONED_FLIGHTS_VALUE_ACCESSOR]
    }),
    __metadata("design:paramtypes", [forms_1.FormBuilder])
], PostponedFlightsComponent);
exports.PostponedFlightsComponent = PostponedFlightsComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/flight-builder/postponed-flights.component.js